import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UThemeWrapperComponent } from './u-theme-wrapper.component';

@NgModule({
  declarations: [UThemeWrapperComponent],
  imports: [CommonModule],
  exports: [UThemeWrapperComponent],
})
export class UThemeWrapperModule {}
